/* global $ */

const Menu = {
  /**
   * Create
   * @return {void}
   */
  create(node, props) {
    this.container = node;
    this.props = props;

    this.createListeners();
  },

  /**
   * Create event listeners
   * @return {void}
   */
  createListeners() {
    $(this.container).on('blur', 'input, textarea', (e) => {
      const $row = this.getRowForEventTarget(e);
      const api = this.getApiForRow($row);

      this.updateRow($row, api);
    });
  },

  /**
   * Get row element based on the event
   * @param  {object} event
   * @return {object}
   */
  getRowForEventTarget(event) {
    return $(event.currentTarget).parents('.dd-item');
  },

  /**
   * Return the API endpoint for the row
   * @param  {object} $row
   * @return {object}
   */
  getApiForRow($row) {
    return $row.data('menu-update-api');
  },

  /**
   * Call an update on the row, this will retrieve all input values and call the API
   * @param  {object} $row
   * @param  {string} api
   * @return {void}
   */
  updateRow($row, api) {
    const values = {};

    $row.find('input, textarea, input[type="radio"]:checked, input[type="checkbox"]:checked').toArray().forEach((input) => {
      values[input.getAttribute('name')] = input.value;
    });

    this.update(values, api);
  },

  /**
   * Call update on the API
   * @param  {object} values
   * @param  {string} api
   * @return {void}
   */
  update(values, api) {
    window.axios({
      method: 'post',
      url: api,
      data: Object.assign(values, {
        _method: 'PUT',
      }),
    })
      .then(() => {
        window.toaster.show('Menu item titel is opgeslagen', 2000);
      })
      .catch(() => {
        window.toaster.show('Er was een probleem bij het opslaan', 3000, 'danger');
      });
  },
};

export default Menu;
